
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { UseFormReturn } from 'react-hook-form';
import { useCTraderAccounts } from '@/hooks/use-ctrader-accounts';
import { useTranslation } from 'react-i18next';

interface CTraderProfileFieldProps {
  form: UseFormReturn<any>;
  disabled?: boolean;
}

export const CTraderProfileField: React.FC<CTraderProfileFieldProps> = ({ 
  form,
  disabled = false
}) => {
  const { t } = useTranslation();
  const { data: ctraderAccounts, isLoading: isLoadingAccounts } = useCTraderAccounts();

  return (
    <FormField
      control={form.control}
      name="csp_account_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('ctrader_profile')}</FormLabel>
          <Select
            onValueChange={field.onChange}
            value={field.value}
            disabled={isLoadingAccounts || disabled}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={t('select_ctrader_profile_first')} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {isLoadingAccounts ? (
                <SelectItem value="loading" disabled>{t('loading_accounts')}</SelectItem>
              ) : ctraderAccounts && ctraderAccounts.length > 0 ? (
                ctraderAccounts.map(account => (
                  <SelectItem key={account.id} value={account.id}>
                    {account.csp_account_name}
                    {account.broker && ` - ${account.broker}`}
                    {account.prop_firm && ` - ${account.prop_firm}`}
                  </SelectItem>
                ))
              ) : (
                <SelectItem value="none" disabled>{t('no_available_trading_accounts')}</SelectItem>
              )}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
